import { get, isArray, isFunction, isNil, isObject } from 'lodash';
import { merge } from '../../../editor/core/highcharts-editor';

const createSeriesOptions = (chart, aggregatedOptions, index) => {
  return {
    color:
      chart?.series?.[index]?.color ||
      chart?.colors?.[index] ||
      aggregatedOptions?.series?.[index]?.color ||
      aggregatedOptions?.colors?.[index],
    label: chart?.series?.[index].name || aggregatedOptions?.series?.[index]?.name, // series[optionsTitle]
    value: index
  };
};

export const getSeries = (option, aggregatedOptions, chart) => {
  const controlledBy = option.controlledBy;
  const controlOptions = get(aggregatedOptions, controlledBy.options);

  let opt = controlOptions.map((_, i) => {
    return createSeriesOptions(chart, aggregatedOptions, i);
  });

  if (controlledBy.preValues) {
    opt.unshift(...controlledBy.preValues);
  }

  return opt;
};

export const extractOptionalArrayVal = (options, property) => {
  const isArray = (property?.rootPath ?? '').includes('[');
  let val = get(options, property.id ?? '');
  if (isNil(val)) {
    if (isArray) {
      val = get(options, property.id?.replace('[0]', '') ?? '');
    } else {
      val = get(options, property.id?.replace(property?.rootPath ?? '', `${property.rootPath}[0]`) ?? '');
    }
  }
  return val;
};

export const extractRefersToVal = (chart, group) => {
  const types = [
    ...new Set([
      chart.userOptions && chart.userOptions.chart ? chart.userOptions.chart.type : 'line',
      ...((chart.userOptions &&
        chart.userOptions.series &&
        chart.userOptions.series.map((serie) => serie.type || 'line')) ||
        [])
    ])
  ];

  let type = 'all';
  let val;

  types.some((chartType) => {
    if (group.refersTo[chartType]) {
      type = chartType;
      return true;
    }
  });

  Object.keys(group.refersTo[type]).some((key) => {
    const props = group.refersTo[type][key];
    const options = chart.options;

    const isThisVal = Object.keys(props).every((prop) => {
      const propVal = get(options, prop);
      if (isArray(propVal) && isArray(props[prop]) && propVal.length === props[prop].length) return true;
      else if (propVal === props[prop]) return true;

      return false;
    });

    if (isThisVal) {
      val = key;
    }
    return isThisVal;
  });

  return val;
};

export const handleRefersToChange = ({ option, chart, val, update, projectType }) => {
  const types = [
    ...new Set([
      chart.userOptions && chart.userOptions.chart ? chart.userOptions.chart.type : 'line',
      ...((chart.userOptions &&
        chart.userOptions.series &&
        chart.userOptions.series.map((serie) => serie.type || 'line')) ||
        [])
    ])
  ];

  let type = 'all';

  types.some((chartType) => {
    if (option.refersTo[chartType]) {
      type = chartType;
      return true;
    }
  });

  if (option.refersTo[type][val]) {
    Object.keys(option.refersTo[type][val]).forEach((id) => {
      const propVal = get(chart.options, id);
      let newVal = option.refersTo[type][val][id];
      if (isArray(propVal) && isObject(propVal[0])) {
        // Used for second yAxis
        newVal.forEach((v, index) => (v = merge(v, propVal[index] || {})));
      }
      update(projectType, id, newVal);

      // if (option.postCondition) option.postCondition(get, aggregatedOptions, newValue, isArray);
    });
  }
};

export const getIndexFromPath = (path) => {
  let index = path.split('[');
  return parseInt(index[index.length - 1], 10);
};

export const getFilteredValue = (option, chart, index) => {
  if (option.filteredBy && isFunction(option.filteredBy)) {
    return option.filteredBy(option, chart, index);
  } else if (option.filteredBy) return option.filteredBy;

  return option.defaultFilterValue;
};
